import { cn } from "@/lib/utils";

import {
  INTRO_EYEBROW,
  INTRO_HEADLINE_LEAD,
  INTRO_HEADLINE_TAIL,
  INTRO_LEDE,
  INTRO_START,
  INTRO_TIME_NOTE,
} from "../copy";
import { HwButton } from "./hw-button";

interface IntroProps {
  onStart: () => void;
  /**
   * Embedded, the headline sits inside a landing-page section, where section
   * titles are h2-sized; on its own page it is the page's h1.
   */
  embedded?: boolean;
}

/** The opening screen, shown until the visitor starts the diagnostic. */
export function Intro({ onStart, embedded = false }: IntroProps) {
  return (
    <div className="max-w-[46ch]">
      <p className="hw-mono">{INTRO_EYEBROW}</p>

      <h1 className={cn("mt-4", embedded ? "hw-h2" : "hw-h1")}>
        {INTRO_HEADLINE_LEAD} <span className="text-hw-blue">{INTRO_HEADLINE_TAIL}</span>
      </h1>

      <p className="hw-lead text-hw-soft mt-6">{INTRO_LEDE}</p>

      <div className="mt-8 flex flex-wrap gap-3">
        <HwButton onClick={onStart}>{INTRO_START}</HwButton>
      </div>

      <p className="text-hw-mute mt-4 max-w-[52ch] text-[13px] leading-[1.5]">{INTRO_TIME_NOTE}</p>
    </div>
  );
}
